<template>
  <div class="gSwiperBox3">
    <swiper :options="swiperOption" :ref="refName">
      <swiper-slide v-for="(item, index) in list.img" :key="index">
        <img :src="item" />
      </swiper-slide>
      <swiper-slide v-if="list.video && list.video.Link">
        <video :src="list.video.Link" :poster="list.video.Img?list.video.Img:''" controls="controls">
          您的浏览器不支持video标签
        </video>
      </swiper-slide>
      <div class="swiper-pagination2" slot="pagination" v-if="list.img.length > 1"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "gSwiperCommon3",
  props: {
    list: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      refName: "",
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination2",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs[this.refName].swiper;
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   this.swiper.slideTo(3, 1000, false);
    this.refName = `mySwiper-${Math.random()}`;
  },
  methods: {}
};
</script>

<style lang="scss">
.gSwiperBox3 {
  .swiper-slide {
    height: 500px;
    img {
      width: 100%;
      height: 100%;
    }
    video {
      width: 100%;
      height: 100%;
      object-fit:fill;
    }
  }
}
.gSwiperBox3 {
  position: relative;
  .swiper-container {
    font-size: 0;
  }
  .swiper-pagination2 {
    position: absolute;
    font-size: 0;
    display: flex;
    justify-content: center;
    bottom: 22px;
    z-index: 2;
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      background-color: #ddd;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background-color: #d13119;
      opacity: 1;
    }
  }
}
</style>